import React from "react";
import SelectInputState, { SelectInputProps } from "./SelectInput.models";

export default class SelectInput extends React.PureComponent<SelectInputProps, SelectInputState> {
    constructor(props: SelectInputProps) {
        super(props);
        this.state = { datas: props.datas, name: props.name, isNullAble: props.isNullAble }
    }

    componentDidUpdate() {
        let self = this;

        self.setState({ datas: this.props.datas, name: this.props.name, isNullAble: this.props.isNullAble });
    }

    render(): React.ReactNode {
        let datas = this.state.datas;
        let name = this.state.name;
        let isNullAble = this.state.isNullAble;

        return (<>
            <select
                id={name}
                name={name}
                defaultValue=''
                className="form-control"
                onChange={e => this.props.value(e.target.value)}
                value={this.props.inputvalue}
            >
                {datas.map(data => (
                    <option key={data.value} value={data.value ?? ''}>
                        {data.title}
                    </option>
                ))}

                <option key='nullRefrence' value='' hidden={!isNullAble}>بدون انتخاب</option>
            </select>
        </>)
    }
}


